import React , {useState , useEffect} from 'react';
import { withRouter } from 'react-router';
import { createApolloFetch } from 'apollo-fetch';
import { useParams } from 'react-router-dom';

import SideProfile from './side-profile.component';
import ProfileInfro from './profile-info.component';
import Speciality from './speciality.component';
import WorkExperience from './work-experience.component';
import Education from './education.component';
import Visumes from './visumes.component';
import NoData from '../../no-data/no-data.component';
// styles , icons and images
import { Row, Col, Tab, Nav } from 'react-bootstrap';
import { Skeleton} from '@material-ui/lab';
// this component respresents the Explore opportunities page
function ApplicantProfile(){
    const { id } = useParams();
    const [userData, setUserData] = useState();

    const fetch = () => {
        const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
        const uri = 'https://spreago.black-squares.com/graphql';
        const apolloFetch = createApolloFetch({ uri });
        apolloFetch.use(({ request, options }, next) => {
            if (!options.headers) {
                options.headers = {};  // Create the headers object if needed.
            }
            options.headers['authorization'] = `Bearer ${token}`;
            next();
        });
        return apolloFetch
    }
    const fetchUserData = () => {
        if (localStorage.jwt) {
            const apolloFetch = fetch();
            //get user data
            apolloFetch({
                query:
                    `query($id : Int){
                      ApplicationFind(id:$id){
                        user{
                          profile_image{
                            url
                          }
                          years_of_experience
                          name
                          headlines
                          bio
                          country{name}
                          city{name}
                          my_bio{
                            title
                            speciality{name}
                            created_at
                            video{url duration  frame{url} duration}
                            is_my_profile_visume
                          }
                          profile_pdf{url}
                          email
                          phone
                          address
                          date_of_birth
                          specialities{
                            id
                             name
                          } 
                          workExperience{
                            id
                            title
                            at_name
                            bio
                            start_time
                            finish_time
                          }
                          Educations{
                            id
                            title
                            at_name
                            bio
                            start_time
                            finish_time
                            
                          }
                           my_bio{
                            title
                          }
                          biosPublished{
                            data{
                              title
                              speciality{name}
                              created_at
                              video{
                                frame{url}
                                url
                                duration
                              }
                            }
                          }
                        }
                      }
                    }`, 
                variables: {
                    id: id
                }
            }).then(res => {
                if (res.data.ApplicationFind) {
                    setUserData(res.data.ApplicationFind.user);
                }else{
                    setUserData("notFound")
                }
            }).catch((err) => console.log(err));
        }
    }
    useEffect(function () {
       fetchUserData();
    },[]);
    
    if(!userData){
        return(
            <main className=" pt-4  container container-fluid-responsive m-h-100">
                <div className="row">
                <Col md={3} className="">
                    <Row className="w-100 pr-4 pl-4 m-0">
                        <Col md={12} className="text-center">
                            <div className="p-relative m-auto" style={{ width: "170px", height: "170px" }}>
                                <Skeleton className="text-center mb-1" variant="circle" animation="wave" width={170} height={170} />
                            </div>
                        </Col>
                        <Col md={12} className=" text-center">
                            <div className="p-relative m-auto w-100">
                                <Skeleton className="text-center mb-1" animation="wave" width={120} height={30} />
                                <Skeleton className="text-center mb-1" animation="wave" height={30} />
                                <Skeleton className="text-center" animation="wave" width={70} height={30} />
                            </div>
                        </Col>
                        <Col md="12">
                            <Skeleton className="text-center" animation="wave" varient="rect" height={120} />
                        </Col> 
                    </Row>
                </Col>
                <Col md={9}>
                    <Skeleton animation="wave" width={170} height={40} />
                    <Skeleton className="mb-2" variant="rect" animation="wave" height={360} />
                </Col>
            </div>
            </main>
        )
    }else if(userData === "notFound"){
        return(
            <main className="mt-5  container  m-h-100">
                <NoData />
            </main>
        )
    }
    else{
        return (
            <>
                <main className="pt-4  container container-fluid-responsive m-h-100">
                    <Row className="m-0">
                        <Col md={3} className="p-0">
                            <SideProfile data={userData}/>
                        </Col>
                        <Col md={9} className="p-0">
                            <Tab.Container defaultActiveKey="first">
                                <Row className="m-0 pt-xs-4">
                                    <Col sm={12} className="mb-2">
                                        <Nav variant="pills" id="left-tabs-example">
                                            <Nav.Item>
                                                <Nav.Link eventKey="first" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                    <h6>Profile</h6>
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="second" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                    <h6>Visuemes</h6>
                                                </Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </Col>
                                    <Col sm={12} id="tab-content-container">
                                        <Tab.Content>
                                            <Tab.Pane eventKey="first">
                                                <ProfileInfro userData={userData}/>
                                                <Speciality data={userData.specialities}/>
                                                <WorkExperience data={userData.workExperience}/>
                                                <Education data={userData.Educations}/>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second" >
                                                <Visumes data={userData?.biosPublished && userData.biosPublished} userName={userData?.name}/>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>
                        </Col>
                    </Row>
                </main>
            </>
        );
    }
}

export default withRouter(ApplicantProfile);